<smrts-dialog [title]="title" [hasFootnote]="true">

  <div class="content custom-table">

    <div class="custom-table-row">
      <div class="custom-table-col one-column-width">
        <p-floatlabel variant="on">
          <input pInputText fluid [ngModel]="tipoAtual?.nome" readonly />
          <label>Tipo que será mesclado</label>
        </p-floatlabel>
      </div>
      <div class="custom-table-col one-column-width">
        <app-generic-autocomplete [items]="tipos" inputId="tipo" displayField="nome" label="Mesclar no tipo"
          [(ngModel)]="tipoSelecionado" (selectionChange)="onSelectionChange()">
        </app-generic-autocomplete>
      </div>
    </div>

    <div class="custom-table-row">
      <div class="custom-table-col two-column-width">
        <p-floatlabel variant="on">
          <input pInputText fluid [(ngModel)]="nomeFinal" />
          <label>Nome final</label>
        </p-floatlabel>
      </div>
    </div>

  </div>

  <div footnote class="inline-element footnote">
    <button class="accent-text-button btn-cancelar" mat-button [mat-dialog-close]="false">
      Cancelar
    </button>
    <button class="white-text-button" mat-flat-button (click)="salvarClick()">
      Salvar
    </button>
  </div>
</smrts-dialog>
